import request from '@/utils/request'

/**
 * 现货收益统计（15min / hour / day 三种颗粒度）
 *
 * 按电站 + 日期区间查询现货收益，由 granularity 决定聚合层次：
 * - 15min：每格一行，timeSlot 形如 00:00 ~ 23:45（一天 96 行）
 * - hour： 每小时一行，timeSlot 形如 00:00 ~ 23:00（一天 24 行）
 * - day：  每天一行，timeSlot 为 null
 *
 * 返回排序固定：日期升序、时段升序、byMeter 时再按 uuid 升序。
 *
 * 注意：收益字段缺价时返回 null（不是 0），且可为负；均价单位是元/兆瓦时。
 *
 * @param {object} params
 * @param {number|string} params.stationId 电站ID，必填
 * @param {string} params.startDate yyyy-MM-dd，含当天，必填
 * @param {string} params.endDate   yyyy-MM-dd，含当天，必填
 * @param {'15min'|'hour'|'day'} [params.granularity='15min'] 颗粒度
 * @param {boolean} [params.byMeter=false] 是否按电表拆开
 * @param {string} [params.uuid] 电表uuid，传了则自动按表粒度
 */
export function getSpotIncomeStat(params) {
  return request({
    url: '/dashboard/v3/spot/income/stat',
    method: 'get',
    params,
  })
}
